import { jsx } from "react/jsx-runtime";
function DefaultBackground() {
  return /* @__PURE__ */ jsx("div", { className: "tl-background" });
}
export {
  DefaultBackground
};
//# sourceMappingURL=DefaultBackground.mjs.map
